/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankDropdown200,
  GetApiV1BankDropdown401,
  GetApiV1BankDropdown500,
  GetApiV1BankDropdownQueryParams,
  GetApiV1BankDropdownQueryResponse,
} from "../../types/bankAuxiliaresController/GetApiV1BankDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1BankDropdownQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  all: z.boolean().default(false),
}) as unknown as ToZod<GetApiV1BankDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1BankDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1BankDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1BankDropdown500>;

export const getApiV1BankDropdownQueryResponseSchema = z.lazy(
  () => getApiV1BankDropdown200Schema,
) as unknown as ToZod<GetApiV1BankDropdownQueryResponse>;
